module.exports = __webpack_public_path__ + "img/retailer-status-bar-lit.496eebc0.svg";